import { makeEnvironmentProviders } from '@angular/core';
import { API_BASE_URL } from '../tokens/api-base-url.token';
import { SIGNALR_HUB_PATH } from '../tokens/signalr-hub-path.token';

export const provideClinicianApi = (
  apiBaseUrl: string,
  signalrHubPath: string
) =>
  makeEnvironmentProviders([
    { provide: API_BASE_URL, useValue: apiBaseUrl },
    { provide: SIGNALR_HUB_PATH, useValue: signalrHubPath },
  ]);
